<template>
  <b-container fluid>
    <b-row>
      <b-col>

        <b-card title="Roles" class="mb-2">

          <b-table striped
                   hover
                   small
                   :items="details.roles"
                   :fields="fields"
                   :sort-by.sync="sortBy"
                   :sort-desc.sync="sortDesc"
                   class="rankingTable">

            <template v-slot:cell(enabled)="data">
              <b-form-checkbox @click.stop v-model="data.item.enabled"></b-form-checkbox>
            </template>

          </b-table>

        </b-card>

      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";

  export default {
    name: 'RolesListComponent',

    components: {
    },

    data() {
      return {

        sortBy: 'username',
        sortDesc: false,
        userList: null,
        fields: [
          {
            key: 'rolename',
            label: 'Role',
            sortable: false
          },
          {
            key: 'realmname',
            label: 'Realm',
            sortable: false
          },
          {
            key: 'enabled',
            label: 'enabled',
            sortable: false,
            class: 'text-center'
          }]
      }
    },

    props: {
      details: Object
    },

    computed: {
      ...mapState(['activeSurvey', 'absoluteDrillPath']),
      ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),
    },

     methods: {
      onEnabledChanging() {
        // console.log("changing!")
      },

      onSubmit() {
          this.$emit('update-details', this.details)
      },

     },

  }
</script>